/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')
  .component('campaignViewCard', {
    bindings: {
      project: '<',
      campaign: '<',
    },
    controller: campaignViewCardController,
    templateUrl: '/templates/zenclerk_s/directives/campaign/view_card/campaign_view_card.html',
  });

campaignViewCardController.$inject = ['$uibModal', 'ZcsCampaign', 'ZcsSegment'];
function campaignViewCardController($uibModal, ZcsCampaign, ZcsSegment) {
  const vm = this;
  vm.$onInit = () => {
    vm.coupon = {};
    vm.openMailMagUrlModal = openMailMagUrlModal;
    vm.getSegmentLabel = ZcsSegment.getSegmentLabel;
    vm.campaignProgress = ZcsCampaign.getCampaignProgress(vm.campaign);
    vm.isCampaignEndingSoon = ZcsCampaign.isCampaignEndingSoon;
    getCouponStyle();
  };

  // get coupon design
  function getCouponStyle() {
    let imageUrl, backgroundColor;

    backgroundColor = vm.campaign.element.message.second_color;
    if(vm.campaign.template_type === 'zcs_image') {
      imageUrl = vm.campaign.element.message.banner;
    } else if(vm.campaign.template_type === 'giftcard') {
      if(vm.campaign.element.message.coupon_pattern.startsWith('http:') || vm.campaign.element.message.coupon_pattern.startsWith('https:')) {
        imageUrl = vm.campaign.element.message.coupon_pattern;
      } else {
        const patternPath = `/assets/campaigns/coupon/giftcard/pattern_${vm.campaign.element.message.coupon_pattern}.jpg`;
        imageUrl = `${ZC_CONFIG.RAILS_API_URL}:${ZC_CONFIG.RAILS_API_PORT}${patternPath}`;
      }
      backgroundColor = vm.campaign.element.message.base_color;
    }

    vm.coupon.style = {
      'background-color': backgroundColor,
      'background-image': 'url("' + imageUrl + '")'
    };
  }

  // mail mag url modal
  function openMailMagUrlModal($event) {
    $event.stopPropagation();
    ZcsCampaign.openMailMagUrlModal(vm.campaign, vm.project);
    vm.isMenuActive = false;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/campaign/view_card/campaign_view_card.js